import { Fragment } from 'react'
import { connect } from 'react-redux'
import { Body1, Caption, Menu, Button } from '../../cdl-react-components/components'
import Link from '../../Utilities/Link'
import Navigation from '../../Utilities/Navigation'
import { removeUser, setConfigurationLoginModalOpen } from '../../../store/actions'
import { AUTH_URL } from '../../cdl-react-components/utilities/constants'

const header = (props) => {
    const toggleLogin = () => props.setConfigurationLoginModalOpen(true)

    const logout = () => {
        props.removeUser()
    }
        
    return (
        <header id="header" className="mdc-elevation--z2">
            {props.user ? (
            <div id="header__top" className="hide-phone">
                {/* <Caption><Link href="https://cdl.canadiandiscovery.com/corporate/products-services/clean-technology">Learn about CDL’s latest Clean Technology initiatives</Link></Caption> */}
                    <Caption><Link href="https://24157678.hs-sites.com/en-ca/2026-cdl-holiday-party-registration">Register for CDL's 2026 Holiday Appreciation Party on November 26, 2026</Link></Caption>
                {/* {props.user ? 
                    (<Caption>Need help? <Link href="/contact">Contact us</Link> for support</Caption>) : 
                    (<Caption>Not a client? <Link href="/contact">Contact us</Link> for subscription details</Caption>) } */}
            </div>
            ) : null}
            <div id="header__middle">
                <Link href="https://cdl.canadiandiscovery.com">
                    <img src="//webfiles.canadiandiscovery.com/public/CDD/images/CDL_Digest-Logo.png" className="header__logo hide-phone" alt="Canadian Discovery Ltd." />   
                    <img src="/static/images/icons/icon-32x32.png" className="hide-tablet hide-desktop" alt="Canadian Discovery Digest" />
                </Link>
                <nav className="header__middle__nav">
                    <Link href="/knowledge-portal" className="lower-button">
                        <Button raised>CDL Knowledge Portal</Button>
                    </Link>
                    <Navigation />
                    {
                        props.user ? (
                            <Fragment>
                                <Menu handle={<Body1 className="header__middle__icon header__middle__icon--user" title={props.user.username}>{props.user.username[0].toUpperCase()}</Body1>}>
                                    <Link href="https://cdl.canadiandiscovery.com/subscriber-portal">Subscriber Portal</Link>
                                    <Link href={AUTH_URL} target="_blank" rel="noreferrer">My&nbsp;Account</Link>
                                    <Link href={'https://share.hsforms.com/1QSb26vDoQ5iV3kRRJYYqSAeds6m'} target="_blank" rel="noreferrer">Manage&nbsp;Email&nbsp;Preferences</Link>
                                    <span onClick={logout}>Logout</span>
                                </Menu>
                            </Fragment>
                        ) : (
                            <Fragment>
                                <span className="header__login" onClick={toggleLogin}>Login</span>
                            </Fragment>
                        )
                    }
                </nav>
            </div>
        </header>
    )
}

const mapStateToProps = ({data, search }) => ({
    user: data.user,
    searchParameters: search.parameters
})

const mapDispatchToProps = (dispatch) => ({
    removeUser: () => dispatch(removeUser()),
    setConfigurationLoginModalOpen: (open) => dispatch(setConfigurationLoginModalOpen(open))
})

export default connect(mapStateToProps, mapDispatchToProps)(header)